import {
  IonButton,
  IonLabel,
  IonCheckbox,
  IonItem,
  IonCard,
  IonCardContent,
  IonCol,
} from "@ionic/react";
import React, { useEffect } from "react";

const BinaryChoice = ({
  setSubmitQuestion,
  setSelected,
  selected,
  setQuestionDetails,
}) => {
  useEffect(() => {
    if (selected === "boolean") {
      setSubmitQuestion(true);
      setQuestionDetails({ type: "boolean" });
    } else {
      setSubmitQuestion(false);
    }
  }, [selected, setSubmitQuestion, setQuestionDetails]);

  return (
    <IonCol size={!selected ? 6 : selected === "boolean" ? 12 : null}>
      <div style={{ height: "185px", display: "flex" }}>
        <div>
          <IonCheckbox
            checked={selected === "boolean"}
            value={"boolean"}
            onIonChange={(e) => {
              e.detail.checked
                ? setSelected(e.detail.value)
                : setSelected(null);
            }}
          />
        </div>
        <IonCard style={{ width: "100%", margin: "0px 10px" }}>
          <IonItem>
            <IonLabel>Ja / Nein</IonLabel>
          </IonItem>

          <IonCardContent>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>Beispiel:</div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  outline: "solid #0000005e 1px",
                  padding: "10px 0px",
                  margin: "10px 0px",
                  height: "75px",
                }}
              >
                <IonButton>Ja</IonButton>
                <IonButton>Nein</IonButton>
              </div>
            </div>
          </IonCardContent>
        </IonCard>
      </div>
    </IonCol>
  );
};

export default BinaryChoice;
